import React, { useEffect } from "react";
import { Container, Button, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faBookOpen } from "@fortawesome/free-solid-svg-icons";
import "./Support.css"; // Optional: for custom tweaks

const Support = () => {
  useEffect(() => {
    document.title = "REACirc Support | RealtyOS";
  }, []);

  return (
    <section
      id="support"
      className="section text-center py-5"
      style={{ backgroundColor: "#f9f9f9" }}
    >
      <Container>
        <h1 className="mb-4">
          <img
            src="/img/reacirc-logo.png"
            alt="REACirc Logo"
            className="logo me-2"
            style={{ height: "40px", verticalAlign: "middle" }}
          />
          REACirc Support
        </h1>
        <p className="intro-description text-muted fs-5 mb-5">
          We're here to support real estate professionals using REACirc.
        </p>

        <Row className="justify-content-center">
          <Col md={5} className="mb-4">
            <div className="option-button email-support shadow-sm">
              <div className="option-icon">
                <FontAwesomeIcon icon={faEnvelope} size="2x" />
              </div>
              <div className="option-text-box">
                <div className="option-text">
                  <h2>Email Support</h2>
                  <p>
                    Have a question or found a bug? Reach out to our team and
                    we'll respond within 1–2 business days.
                  </p>
                  <Button variant="primary" href="mailto:support@realtyos.co">
                    Email Us
                  </Button>
                </div>
              </div>
            </div>
          </Col>

          <Col md={5} className="mb-4">
            <div className="option-button knowledge-base shadow-sm disabled">
              <div className="option-icon">
                <FontAwesomeIcon icon={faBookOpen} size="2x" />
              </div>
              <div className="option-text-box">
                <div className="option-text">
                  <h2>Knowledge Base (Coming Soon)</h2>
                  <p>
                    We’re working on a full support guide with FAQs, tutorials,
                    and setup help.
                  </p>
                  <Button variant="secondary" disabled>
                    Coming Soon
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Row className="mt-4">
          <Col>
            <p className="text-muted">
              REACirc is a product of RealtyOS. Visit our{" "}
              <a href="/about" className="text-decoration-none">
                About Us
              </a>{" "}
              page to learn more.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Support;
